import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    TaxCodeDto, TaxCodePaginator,
    CreateCompanyTaxCodeDto, QueryTaxCodeDto,
    UpdateTaxCodeDto, SetDefaultTaxCodeDto, SearchTaxCodeDto
} from "../models/tax-code.dto";
import ENDPOINTS from "./utils/endpoints";

export function useGetCompanyTaxCode(companyId: number, options?: QueryTaxCodeDto) {
    const url = ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_CODE.GET;
    const request = API.ProcessingCompanyAPI.getCompanyTaxCode(companyId, options);

    const { data, isLoading, error, refetch } = useQuery<TaxCodePaginator, Error>(
        [url, companyId],
        (() => request),
        {...API.Handlers.pageParamOption}
    );

    return { data, isLoading, error, refetch };
}

export function useGetCompanyTaxCodeSearch() {

    return useMutation(
        (companyId: number, options?: SearchTaxCodeDto) => API.ProcessingCompanyAPI.getCompanyTaxCodeSearch(companyId, options),
        {
            onSuccess: () => {
                //toast.success('Record created successfully');
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}

export function useGetCompanyTaxCodeById(companyId: number, id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_CODE.DETAIL;
    const request = API.ProcessingCompanyAPI.getCompanyTaxCodeById(companyId, id);

    const {data, isLoading, error} = useQuery<{ data: TaxCodeDto }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreateCompanyTaxCode() {
    const queryClient = useQueryClient();

    return useMutation(
        ({companyId, payload}: {companyId: number, payload: CreateCompanyTaxCodeDto}) => API.ProcessingCompanyAPI.createCompanyTaxCode(companyId, payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_CODE.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateCompanyTaxCode() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, companyId, id}: {payload: UpdateTaxCodeDto, companyId: number, id: number}) => API.ProcessingCompanyAPI.updateCompanyTaxCode(companyId, id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_CODE.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteCompanyTaxCode() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ companyId, id }: { companyId: number, id: number }) => API.ProcessingCompanyAPI.deleteCompanyTaxCode(companyId, id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_CODE.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useSetDefaultTaxCode() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, companyId, id}: {payload: SetDefaultTaxCodeDto, companyId: number, id: number}) => API.ProcessingCompanyAPI.setDefaultCompanyTaxCode(companyId, id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_CODE.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}
